import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const foeroomshiftApi = api
  .enhanceEndpoints({ addTagTypes: ['FOERoomShift'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFOERoomShifts: builder.query<(fo_echeckin & fo_eroomshift)[], string>({
        query: cid => `foeroomshift/${cid}`,
        providesTags: ['FOERoomShift']
      }),
      getFOERoomShiftById: builder.query<fo_eroomshift, string>({
        query: id => `foeroomshift/byid/${id}`,
        providesTags: ['FOERoomShift']
      }),
      insertFOERoomShift: builder.mutation({
        query: foeroomshift => ({
          url: `foeroomshift/`,
          method: 'POST',
          body: foeroomshift
        }),
        invalidatesTags: ['FOERoomShift']
      }),
      updateFOERoomShift: builder.mutation({
        query: foeroomshift => ({
          url: `foeroomshift/`,
          method: 'PUT',
          body: foeroomshift
        }),
        invalidatesTags: ['FOERoomShift']
      }),
      deleteFOERoomShift: builder.mutation({
        query: foeroomshift => ({
          url: `foeroomshift/${foeroomshift.rs_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['FOERoomShift']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFOERoomShiftsQuery,
  useGetFOERoomShiftByIdQuery,
  useInsertFOERoomShiftMutation,
  useUpdateFOERoomShiftMutation,
  useDeleteFOERoomShiftMutation
} = foeroomshiftApi;

